/**
 * @file: RowErrorText.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { ErrorText } from '@euler/components/form/Input';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import {
  ValidateError,
  getValidateErrorMessage,
} from '@euler/lib/form/controller';
import { memo } from 'react';

/**
 * the validation message of a row that has no `Cell` to host it — pass it as
 * the row's `note`, so it sits under the title and lines up with it.
 */
export const RowErrorText = memo(({ error }: { error?: ValidateError }) => {
  const { rpx } = useResponsiveContext();
  if (error == null) return null;
  return (
    <ErrorText
      errorMsg={getValidateErrorMessage(error)}
      css={`
        margin-left: ${rpx(10)}px;
        margin-top: ${rpx(5)}px;
      `}
    />
  );
});
